import React, { Component } from 'react'

export default class Loading extends Component {
    state = {
        loading: false,
        loadingPercent: 0,
    };
    componentDidMount() {
        let interval = setInterval(() => {
            if (this.state.loadingPercent + 1 >= 100) {
                clearInterval(interval);
                return;
            }
            this.setState(state => ({ ...state, loadingPercent: state.loadingPercent + 1 }))
        }, 300);
    }
    render() {
        return (
            <div>
                <div className='pace' style={{ textAlign: 'center', padding: '1rem 0' }}>
                    <div className='load-progress'></div>
                    <div className='load-progress1'></div>
                </div>
                <div style={{textAlign:'center', marginTop:'6rem'}}>
                    {this.state.loadingPercent} %
                </div>

            </div>

        )
    }
}
